import { Switch } from "V2.0/common/switch";

export default function FollowUpAutomateToggle({ isEnabled, onToggle , disabled}) {
  const handleToggle = async () => {
    onToggle(!isEnabled);
  };

  return (
    <Switch
      color="emerald"
      id={`checkbox-${isEnabled}`}
      checked={isEnabled}
      onClick={handleToggle}
      disabled={disabled}
    />
  );
}
